import { generateConfig } from "@dytesdk/react-ui-kit";
import { UIConfig } from "@dytesdk/ui-kit";
import DyteClient from "@dytesdk/web-core";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

import { CustomStates, SetStates } from "../types/dyte";
import { DyteStateListenersUtils } from "./dyte-meeting-listeners";

export async function setupMeetingConfigs(
  meeting: DyteClient,
  states: CustomStates,
  setStates: SetStates,
  setConfig: (config: UIConfig) => void
) {
  const theme = meeting!.self.config;
  // @ts-ignore
  const { config } = generateConfig(theme, meeting!);

  setConfig({ ...config });

  /**
   * NOTE(ravindra-dyte):
   * Add listeners on meeting & self to monitor leave meeting, join meeting and so on.
   * This work was earlier done by DyteMeeting component internally.
   */
  const stateListenersUtils = new DyteStateListenersUtils(
    // @ts-ignore
    () => meeting,
    () => states,
    () => setStates
  );
  stateListenersUtils.addDyteEventListeners();
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
